import { Sujeto as ISujeto } from 'src/interfaces'
import { isOrganoJudicial, isProfesional } from 'src/utils/sujeto'
import OrganoJudicial from './OrganoJudicial'
import Profesional from './Profesional'

type Props = {
  sujeto: ISujeto
}

function Sujeto({ sujeto }: Props): JSX.Element | null {
  if (isOrganoJudicial(sujeto)) {
    return <OrganoJudicial organoJudicial={sujeto} />
  }

  if (isProfesional(sujeto)) {
    return <Profesional profesional={sujeto} />
  }

  return null
}

export default Sujeto
